module.exports = __webpack_public_path__ + "img/app-tangxin.79eac86b.webp";